/* One-row Heritage collection; scroll and touch remain usable without JS. */
(function () {
  function init(scope) {
    scope.querySelectorAll('[data-heritage-collection]').forEach(function (root) {
      if (root.dataset.carouselReady) return;
      root.dataset.carouselReady = 'true';
      var track = root.querySelector('[data-carousel-track]');
      var controls = root.querySelector('[data-carousel-controls]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var status = root.querySelector('[data-carousel-status]');
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 2;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
        status.textContent = 'Explore ' + track.querySelectorAll('.product-card').length + ' options';
      }
      function move(direction) {
        var card = track.querySelector('.product-card');
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('keydown', function (e) { if (e.target !== track) return; if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } });
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
